"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const context_1 = require("../../context");
exports.OsmosysFormButton = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const { submit, result } = context_1.useOsmosysForm();
    return (react_1.default.createElement(react_2.OsmosysButton, Object.assign({ osysName: "OsmosysFormButton", osysStyle: "save", mutate: submit, mutationResult: result }, props), children || 'Save'));
};
//# sourceMappingURL=index.js.map